var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("bootstrap-box", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("advanced-sankey-diagram", {
              attrs: { "initial-journey-id": _vm.initialJourneyId }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }